import React, { Component } from 'react';
import { Button } from '@eg/elements/Button';
import { ArrowRightIcon } from '@eg/elements/Icons/ArrowRightIcon';

import CheckoutNavigation from '../../../components/shared/checkout-navigation/CheckoutNavigation';
import PrivacyInformation from '../../../components/shared/privacy-information/PrivacyInformation';
import FirstInformation from '../../../components/shared/first-information/FirstInformation';

import { clearSessionStorage } from '../../common/SessionHandler';

import './PayPal.scss';

class PayPal extends Component {
  constructor(props) {
    super(props);
    this.state = {payPalCheck: false}
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    if(sessionStorage.getItem('approvalUrl') === null && sessionStorage.getItem('insuranceStartDate') != null ) {
      this.props.history.push("/internet-schutzbrief/persoenliches");
    } else if(sessionStorage.getItem('insuranceStartDate') === null || sessionStorage.getItem('approvalUrl') === null || !this.checkTimer()) {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/tarifdaten");
      window.scrollTo(0, 0);
    } else {
      window.PAYPAL.apps.PPP({
        "approvalUrl": sessionStorage.getItem('approvalUrl'),
        "placeholder": "ppplus",
        "mode": sessionStorage.getItem('mode'),
        "country": "DE",
        "language": "de_DE",
        "preselection": "paypal",
        "buttonLocation": "outside",
        "disableContinue": "continueButton",
        "enableContinue": "continueButton",
        "showLoadingIndicator": true,
        "onLoad": () => {
           this.setState({
             payPalCheck: true
           });
        }
      });
    }
  }

  handleClick() {
    if(this.checkTimer()) {
      window.PAYPAL.apps.PPP.doCheckout();
    } else {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/tarifdaten");
      window.scrollTo(0, 0);
    }
  }

  checkTimer = () => {
    var now = new Date();
    var start = new Date (sessionStorage.getItem('timestamp'));
    var diff =(now.getTime() - start.getTime()) / 1000;
    var res;

    diff /= 60;
    res = Math.abs(Math.round(diff));

    return (res < 30);
  }

  render() {
    return (
      <div className="esc_container outerContainer" id="paypal">
        <div className="esc_container esc_container--l">
          <CheckoutNavigation step="2" />
          <PrivacyInformation />
          <h1>Zahlungsoptionen</h1>
          <p>
            Bitte wählen Sie eine der angegebenen Zahlungsoptionen zur Bezahlung Ihres Einmalbeitrags aus. Mit dem Klick auf „Weiter“ kommen Sie zur Eingabe der Zahlungsdaten auf die Seite von PayPal PLUS.
            Im Anschluss daran folgt der weitere Vertragsabschluss auf unserer Homepage.
          </p>
          <hr />
          <div id="ppp_result">
            <div id="ppplus" />
            { this.state.payPalCheck ? <FirstInformation /> : null }
          </div>
          <Button id="continueButton" onClick={this.handleClick} variant="primary" iconRight={ArrowRightIcon} size="auto" style={{ float: "right" }}>Weiter</Button>
        </div>
      </div>
    );
  }
}

export default PayPal;
